import { useSelector } from 'react-redux';
import { getQuoteInstrument } from 'state/clientWorkspace/selectors';
import type { AppState } from 'state/model';

export const useQuoteType = (quoteId: string) =>
  useSelector((state: AppState) => getQuoteInstrument(state, quoteId));
